export const AUDIENCES_TYPE = {
  // 不限
  NO_LIMIT: 0,
  // 开启
  LIMITED: 1
}
export const AGES = [
  {
    label: '14~18岁',
    value: '14,18'
  },
  {
    label: '19~24岁',
    value: '19,24'
  },
  {
    label: '25~29岁',
    value: '25,29'
  },
  {
    label: '30~39岁',
    value: '30,39'
  },
  {
    label: '40~49岁',
    value: '40,49'
  },
  {
    label: '50岁及以上',
    value: '50,66'
  }
]

/**
 * @description: 网络类型
 */
export const NETWORKS = [
  {
    label: 'WIFI',
    value: 'WIFI'
  },
  {
    label: 'NET_2G',
    value: '2G'
  },
  {
    label: 'NET_3G',
    value: '3G'
  },
  {
    label: 'NET_4G',
    value: '4G'
  },
  {
    label: 'NET_5G',
    value: '5G'
  }
]

/**
 * @description: 设备价格
 * @return {*}
 */
export const DEVICE_PRICES = [
  {
    label: '4500元以上',
    value: 'PRICE_4500_MORE'
  },
  {
    label: '3500~4500元',
    value: 'PRICE_3500_4500'
  },
  {
    label: '2500~3500元',
    value: 'PRICE_2500_3500'
  },
  {
    label: '1500~2500元',
    value: 'PRICE_1500_2500'
  },
  {
    label: '1500元以下',
    value: 'PRICE_1500_LESS'
  }
]

/**
 * @description: 排除已转化用户，自定义转化行为
 */
export const CONVERSION_BEHAVIOR = {
  FOLLOW: 'OPTIMIZATIONGOAL_FOLLOW',
  CLICK: 'OPTIMIZATIONGOAL_CLICK',
  APP_DOWNLOAD: 'OPTIMIZATIONGOAL_APP_DOWNLOAD',
  APP_ACTIVATE: 'OPTIMIZATIONGOAL_APP_ACTIVATE',
  APP_REGISTER: 'OPTIMIZATIONGOAL_APP_REGISTER',
  ONE_DAY_RETENTION: 'OPTIMIZATIONGOAL_ONE_DAY_RETENTION',
  PAGE_SCAN_CODE: 'OPTIMIZATIONGOAL_PAGE_SCAN_CODE',
  CANVAS_CLICK: 'OPTIMIZATIONGOAL_CANVAS_CLICK',
  PAGE_RESERVATION: 'OPTIMIZATIONGOAL_PAGE_RESERVATION'
}
export const CONVERSION_BEHAVIOR_LIST = [
  { value: CONVERSION_BEHAVIOR.FOLLOW, label: '关注' },
  { value: CONVERSION_BEHAVIOR.CLICK, label: '点击' },
  { value: CONVERSION_BEHAVIOR.APP_DOWNLOAD, label: '下载' },
  { value: CONVERSION_BEHAVIOR.APP_ACTIVATE, label: '激活' },
  { value: CONVERSION_BEHAVIOR.APP_REGISTER, label: '注册' },
  { value: CONVERSION_BEHAVIOR.ONE_DAY_RETENTION, label: '次日留存' },
  { value: CONVERSION_BEHAVIOR.PAGE_SCAN_CODE, label: '加企业微信客服' },
  { value: CONVERSION_BEHAVIOR.CANVAS_CLICK, label: '跳转按钮点击' },
  { value: CONVERSION_BEHAVIOR.PAGE_RESERVATION, label: '表单预约' }
]

export const DISPLAY_SCENE = {
  BANNER: 'DISPLAY_SCENE_BANNER',
  INLINE: 'DISPLAY_SCENE_INLINE',
  SPLASH: 'DISPLAY_SCENE_SPLASH',
  NATIVE: 'DISPLAY_SCENE_NATIVE',
  VIDEO: 'DISPLAY_SCENE_REWARDED_VIDEO'
}
export const DISPLAY_SCENE_LIST = [
  { value: DISPLAY_SCENE.BANNER, label: 'Banner' },
  { value: DISPLAY_SCENE.INLINE, label: '插屏' },
  { value: DISPLAY_SCENE.SPLASH, label: '开屏' },
  { value: DISPLAY_SCENE.NATIVE, label: '原生' },
  { value: DISPLAY_SCENE.VIDEO, label: '激励视频' }
]

export const LOCATION_TYPES = {
  RECENTLY_IN: 'RECENTLY_IN',
  LIVE_IN: 'LIVE_IN',
  TRAVEL_IN: 'TRAVEL_IN',
  VISITED_IN: 'VISITED_IN'
}

export const LOCATION_TYPES_LIST = [
  { value: LOCATION_TYPES.RECENTLY_IN, label: '近期在这里的人' },
  { value: LOCATION_TYPES.LIVE_IN, label: '常住这里的人' },
  { value: LOCATION_TYPES.TRAVEL_IN, label: '旅行到这里的人' },
  { value: LOCATION_TYPES.VISITED_IN, label: '去过这里的人' }
]

export const WECHAT_AD_BEHAVIORS = {
  WECHAT_OFFICIAL_ACCOUNT_AD_LIKE: 'WECHAT_OFFICIAL_ACCOUNT_AD_LIKE',
  WECHAT_MOMENTS_AD_LIKE: 'WECHAT_MOMENTS_AD_LIKE',
  MINI_GAME_WECHAT_REGISTERED: 'MINI_GAME_WECHAT_REGISTERED',
  WECHAT_OFFICIAL_ACCOUNT_FOLLOWED: 'WECHAT_OFFICIAL_ACCOUNT_FOLLOWED'
}
export const WECHAT_AD_BEHAVIORS_LIST = [
  {
    label: '曾对你的公众号感兴趣',
    value: WECHAT_AD_BEHAVIORS.WECHAT_OFFICIAL_ACCOUNT_AD_LIKE
  },
  {
    label: '曾对你的朋友圈感兴趣',
    value: WECHAT_AD_BEHAVIORS.WECHAT_MOMENTS_AD_LIKE
  },
  {
    label: '已注册你的小游戏',
    value: WECHAT_AD_BEHAVIORS.MINI_GAME_WECHAT_REGISTERED
  },
  {
    label: '已关注过你的公众号',
    value: WECHAT_AD_BEHAVIORS.WECHAT_OFFICIAL_ACCOUNT_FOLLOWED
  }
]

export const WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY = [
  {
    label: '30日以上未活跃',
    value: 'THIRTY_DAYS_NO_ACTIVE'
  },
  {
    label: '15日以上未活跃',
    value: 'FOURTEEN_DAYS_NO_ACTIVE'
  },
  {
    label: '7日以上未活跃',
    value: 'SEVEN_DAYS_NO_ACTIVE'
  }
]

export const EXCLUDED_CONVERSIONS = {
  UID: 'EXCLUDED_DIMENSION_UID',
  BUSINESS_MANAGER: 'EXCLUDED_DIMENSION_BUSINESS_MANAGER',
  COMPANY_ACCOUNT: 'EXCLUDED_DIMENSION_COMPANY_ACCOUNT',
  APP: 'EXCLUDED_DIMENSION_APP'
}

export const EXCLUDED_CONVERSIONS_LIST = [
  { value: EXCLUDED_CONVERSIONS.UID, label: '同账号计划' },
  { value: EXCLUDED_CONVERSIONS.BUSINESS_MANAGER, label: '同商务管家计划' },
  { value: EXCLUDED_CONVERSIONS.COMPANY_ACCOUNT, label: '同主体计划' },
  { value: EXCLUDED_CONVERSIONS.APP, label: '同应用' }
]

export const EXCLUDED_DAY = {
  ONE_DAY: 'EXCLUDED_DAY_ONE_DAY',
  SEVEN_DAY: 'EXCLUDED_DAY_SEVEN_DAY',
  ONE_MONTH: 'EXCLUDED_DAY_ONE_MONTH'
}
